export const CONSENT_BANNER_USER_PREFERENCES = 'CONSENT_BANNER_USER_PREFERENCES';
export const CONSENT_BANNER_USER_PREFERENCES_SSR = 'CONSENT_BANNER_USER_PREFERENCES_SSR';
export const CONSENT_BANNER_USER_PREFERENCES_KEY = 'CONSENT_BANNER_USER_PREFERENCES_KEY';
